// extracted by mini-css-extract-plugin
export default {"warning":"warning__4T8XO","prefix":"prefix__VyvaF","blue":"blue__x1smP","green":"green__XBUyr"};